export const baseTheme = {
  color: {},
  fontSize: [],
};



// WEBPACK FOOTER //
// ./src/themes/baseTheme.ts